import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";

export default class V1GroupFinalResult extends BaseIncomingPayload {
  public readonly payload: V1GroupFinalResultPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_GROUP_FINAL_RESULT);

    this.payload = new V1GroupFinalResultPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1GroupFinalResultPayload {
  public readonly group_id: string;
  public readonly best_restaurant: string;

  constructor(payload: Record<string, unknown>) {
    this.group_id = ParseUtils.parseString(payload, "group_id");
    this.best_restaurant = ParseUtils.parseString(payload, "best_restaurant");
  }
}
